
import { TObject } from "../../common/TObject";
import { iData, iDataResult } from "./Data";

export type APIStatus = [number, string, string, number, string]

export class Status extends TObject implements iData{

    apicall:string = '/status';
    cache:APIStatus[]|false = false;

    get() {
        return new Promise<APIStatus[]>((resolve) => {
            if (this.cache) {
                return resolve(this.cache);
            }
        return this.CRMMap().APICall(this.apicall)
    .then((data: {data:APIStatus[]}) => {
            this.cache = data.data;
            this.trigger('refreshed',this.cache );
            return resolve(this.cache);
        });
    });
    }

    invaledate () {
        this.cache = false;
        this.trigger('invaledate');
    }


    save(slug:string, savedata) {
        this.debug('save', slug);
             
        if (slug == 'false' || !slug) {
            slug = "";
        }
        return this.CRMMap().APICall(this.apicall + "/" + encodeURIComponent(slug),
         () => {
            this.invaledate();
        }, 'POST', savedata);

    }


  
    OnStatusChanged = function (callback) {
        $(document).bind('CRMAMP.Status.onChanged', callback);
    }

    LoadStatus = function (callback) {
    this.CRMMap().APICall('status', function (data, api) {
            api.Status = data.data;

            if (typeof callback === 'function') {
                callback();
            }

            $(document).trigger('CRMAMP.Status.onChanged');
        }
    );
}

}

